import { Download } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * No API endpoint exists to fetch/download a DDI report file today — `/due-diligence/reports`
 * only resolves report type names (see requirements.md REQ-9 blocker). Per the issue, this
 * section must never show a blank state, so the tab renders with the download action visibly
 * disabled rather than being omitted. Wire the real download once a backend endpoint ships.
 */
export const ReportsDdiContent = () => {
  return (
    <div className="flex flex-col gap-4 w-full px-6 py-6 text-sm">
      <div className="flex flex-row items-center justify-between p-4 rounded-lg bg-[#F5F5F5]">
        <span className="text-placeholder">Report download is not yet available.</span>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span>
                <button type="button" disabled aria-disabled="true" className="cursor-not-allowed opacity-50">
                  <Download className="h-5 w-5" />
                </button>
              </span>
            </TooltipTrigger>
            <TooltipContent>Report download is pending a backend update.</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </div>
  );
};

export default ReportsDdiContent;
